import React, { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import Button, { ButtonVariant } from '../Button/Button';

import './LinkButton.scss';

export interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  disabled?: boolean;
}

const LinkButton: FC<LinkButtonProps> = ({
  children,
  variant = 'default',
  fullWidth = false,
  className = '',
  disabled = false,
  ...props
}) =>
  disabled ? (
    <Button variant={variant} className={className} fullWidth={fullWidth} disabled>
      {children}
    </Button>
  ) : (
    <Link
      {...props}
      className={`enkrateia-button enkrateia-link-button variant-${variant} ${
        fullWidth ? 'full-width' : ''
      } ${className}`}
    >
      {children}
    </Link>
  );

export default LinkButton;
